import { IMember } from "../types/person";
import { getMembersRequest, searchMembersGlobalRequest } from "../services/members/members.api";
import { createCSStore } from "./newStores";

type MembersStoreType = {
  members: IMember[];
  isLoading: boolean;
}

export const membersStore = createCSStore("MembersStore")
  .state<MembersStoreType>({
    members: [],
    isLoading: false
  })
  .actions((store) => ({
    searchMember: async (searchKeyword: string) => {
      store.isLoading.set(true);
      try {
        const response = await searchMembersGlobalRequest({ _q: searchKeyword });
        const members = response.data;
        store.members.set(members);
      } catch (error) {
        console.error('Error searching members:', error);
      } finally {
        store.isLoading.set(false);
      }
    },

    resetMembers: () => {
      store.members.set([]);
    }
  })); 